import React, { useState } from "react";

const FormWithBookmarkletAndStringGenerator = () => {
  const [parteId, setParteId] = useState("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [generatedString, setGeneratedString] = useState("");
  const [bookmarkletUrl, setBookmarkletUrl] = useState("");

  const handleFetchData = async () => {
    if (!parteId.trim()) return;
    setStatus("loading");

    try {
      const response = await fetch(
        `http://54.165.34.212:5000/scrape/${parteId}`
      );
      const json = await response.json();
      const data = json.data;

      const general = data.generalData || {};
      const vehicle = data.vehiclesInvolved?.[0] || {};
      const injured = data.injuredPersons?.[0] || {};

      const values = [
        general["NATURALEZA DEL LOCAL"]?.replace(/^:\s*/, "") || "",
        vehicle.brand || "",
        vehicle.model || "",
        vehicle.plate || "",
        injured.name || "",
        injured.age || "",
        injured.location || "",
        vehicle.driverName || "",
        general["RELACIÓN AMPLIA DEL ORIGEN Y LA CAUSA"]?.replace(
          /^:\s*/,
          ""
        ) || "",
      ];

      const generated = values.join(" | ");
      setGeneratedString(generated);
      setStatus("success");

      const bookmarkletCode = `
        (function() {
          let input = prompt("Pega aquí el string de datos:");
          if (input) {
            const fields = input.split('|').map(f => f.trim());
            document.getElementById('naturaleza_detalle').value = fields[0] || '';
            document.getElementById('vehacci_marca').value = fields[1] || '';
            document.getElementById('vehacci_modelo').value = fields[2] || '';
            document.getElementById('vehacci_ppu').value = fields[3] || '';
            document.getElementById('acci_nombre').value = fields[4] || '';
            document.getElementById('acci_edad').value = fields[5] || '';
            document.getElementById('acci_lugar').value = fields[6] || '';
            document.getElementById('duenos').value = fields[7] || '';
            document.getElementById('relacion_causaorigen_detalle').value = fields[8] || '';
          }
        })();
      `;
      setBookmarkletUrl(`javascript:${encodeURIComponent(bookmarkletCode)}`);
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <main
      className="container"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <article style={{ maxWidth: "600px", width: "100%" }}>
        <header>
          <h1>Generador de Bookmarklet</h1>
          <p>Ingresa el ID del parte para generar los datos automáticamente.</p>
        </header>

        <label htmlFor="parteId">ID del Parte</label>
        <input
          id="parteId"
          type="text"
          value={parteId}
          onChange={(e) => setParteId(e.target.value)}
          placeholder="Ej: 123456"
        />

        <button onClick={handleFetchData}>Generar</button>

        {status === "loading" && (
          <progress aria-busy="true">Cargando...</progress>
        )}

        {status === "error" && (
          <p role="alert" style={{ color: "red" }}>
            ⚠️ Hubo un error al obtener los datos.
          </p>
        )}

        {status === "success" && (
          <>
            <h2>🧬 String generado</h2>
            <textarea readOnly rows={6}>
              {generatedString}
            </textarea>

            <h2>🔖 Bookmarklet</h2>
            <p>Arrastra este enlace a tu barra de favoritos:</p>
            <a href={bookmarkletUrl} draggable="true" role="button">
              📌 Bookmarklet
            </a>
          </>
        )}
      </article>
    </main>
  );
};

export default FormWithBookmarkletAndStringGenerator;
